import { atom } from "recoil"
import { GroupMember } from "src/types/organization/group/GroupMember"

export const groupMemberListState = atom<GroupMember[]>({
  key: "atoms/organization/group/groupMemberListState",
  default: [],
})
